import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from '@/lib/queryKeys'

import { getPackageFeesByPackageId } from '../packageReqService'

export const usePackageFeesFromRequests = (pkgId: string | undefined) => {
  return useQuery({
    queryKey: [QUERY_KEYS.PACKAGE_REQUESTS_FEES, pkgId],
    queryFn: () => getPackageFeesByPackageId(pkgId!),
    enabled: !!pkgId,
  })
}
